import { ModuleFE_MeasurementUnit } from './ModuleFE_MeasurementUnit.js';
export const ModulePackFE_MeasurementUnit = [ModuleFE_MeasurementUnit];
//# sourceMappingURL=module-pack.js.map